import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import FinalTreatmentOwnTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import finalIcon from "../../../../../assets/design-revamp-company/category-icons/final-treatment-own-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const FinalTreatmentOwnContents = ({ productId, category }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 2000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="final-treatment-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={
            category === "Product Own Not Received"
              ? t("FINAL_TREATMENT_OWN_NOT_RECEIVE")
              : t("FINAL_TREATMENT_OWN_RECEIVE")
          }
          subDescription={
            category === "Product Own Not Received"
              ? t("FINAL_TREATMENT_OWN_NOT_RECEIVE_DESC")
              : t("FINAL_TREATMENT_OWN_RECEIVE_DESC")
          }
          isNormal={true}
          number={category === "Product Own Not Received" ? "17.1A" : "17.2A"}
          icon={finalIcon}
        />
      </div>
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-finaltreatmentown-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <FinalTreatmentOwnTable productId={productId} category={category} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default FinalTreatmentOwnContents;
